import { useQuery } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'

export function useQueryStickerPackages() {
	return useQuery({
		queryKey: chatKeys.stickerPackages(),
		queryFn: () => chatService.getStickerPackages(),
		staleTime: 1000 * 60 * 60, // 1 hour - sticker packages rarely change
	})
}
